import { LayoutDashboard, Target, Share2, Megaphone, CalendarDays, PlusSquare, ClipboardCheck, Send, BarChart3, Image, Settings, ContactRound } from 'lucide-react';

export const navItems = [
  { name: 'Dashboard', icon: LayoutDashboard },
  { name: 'Workspaces', icon: Target },
  { name: 'Creators', icon: ContactRound },
  { name: 'Social Accounts', icon: Share2 },
  { name: 'Campaigns', icon: Megaphone },
  { name: 'Content Calendar', icon: CalendarDays },
  { name: 'Create Post', icon: PlusSquare },
  { name: 'Review Queue', icon: ClipboardCheck },
  { name: 'Publish Jobs', icon: Send },
  { name: 'Analytics', icon: BarChart3 },
  { name: 'Asset Library', icon: Image },
  { name: 'Settings', icon: Settings },
];
